const MedicineDictionarySectionDivider = () => {
  return <div className='h-[16px] w-full bg-gray-30' />;
};

export default MedicineDictionarySectionDivider;
